<template>
  <div class="swiper-slide">
    <slot></slot>
  </div>
</template>
<script>
/**
   * @describe 需与swiper组件配合使用
   *
   * @example
   *
    <swiper loop pagination v-fill="{fill: !bannerList.length, height: '2.25rem'}">
      <swiper-slide v-for="(item, index) in bannerList" :key="index"><img :src="item" alt=""></swiper-slide>
    </swiper>
   */

export default {
  name: 'swiperSlide',
  props: {
    value: {},
  },
  data() {
    return {};
  },
  updated() {
    this.update();
  },
  mounted: function () {
    this.$nextTick(() => { this.update(); });
  },
  methods: {
    update() {
      if (this.$parent && this.$parent.swiper) {
        this.$parent.initSwiper();
        this.$parent.update();
      }
    }
  },
};

</script>
<style lang="scss">
  .swiper-slide{
    height: 1.25rem;
    overflow: hidden;
    img{
      width: 100%;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/swiperslide.vue